/* ============================================================================
 * spa-collection.js — APS spa COLLECTION filtering / sort / colour-swatch.
 * ----------------------------------------------------------------------------
 * Ported from collection-optimised.html. Filters by reading data-* attributes
 * off the server-rendered cards (no embedded PRODUCTS array). Kept: People
 * quick-chips + Series + Power on-screen, the full slide-over + desktop rail
 * (People / Power / Price / Range / Size / Colour), Series grouping show/hide,
 * the sort dropdown (flatten + hide dividers) and the per-card colour swatch.
 * Removed (prototype-only): the floating accent-colour switcher and all
 * ?embed / postMessage code — accent is permanently locked to brand blue.
 * Wrapped in DOMContentLoaded with a double-init guard.
 * ==========================================================================*/
(function () {
  'use strict';

  function init() {
    if (window.__apsSpaCollectionInit) return;
    var GRID = document.getElementById('grid');
    if (!GRID) return; // not the collection page
    window.__apsSpaCollectionInit = true;

    // facet definitions (shared by mobile panel + desktop rail)
    var FACETS = [
      { key: 'people', title: 'People', hint: 'How many will use it?', type: 'multi',
        opts: [['2', '2 seater'], ['4', '4 seater'], ['5', '5 seater'], ['6', '6 seater']] },
      { key: 'power', title: 'Power &amp; Install', hint: 'Plug-in needs no electrician', type: 'multifull',
        opts: [['plugin', 'Plug-in', '10amp · standard outlet'], ['hardwired', 'Hardwired', '32amp · electrician']] },
      { key: 'price', title: 'Price', hint: '', type: 'price' },
      { key: 'range', title: 'Range', hint: 'More jets &amp; features as you go up', type: 'multi',
        opts: [['deluxe', 'Deluxe'], ['platinum', 'Platinum'], ['luxury', 'Luxury']] },
      { key: 'size', title: 'Size / Footprint', hint: 'Will it fit your space?', type: 'multi',
        opts: [['compact', 'Compact'], ['medium', 'Medium'], ['large', 'Large']] },
      { key: 'colour', title: 'Colour', hint: 'Every spa comes in all three', type: 'sw',
        opts: [['black', 'Black Opal', '#111'], ['white', 'White Opal', '#eef2f5'], ['blue', 'Blue Opal', '#2f5d8c']] }
    ];
    var PRICE_BANDS = [['0-4999', 'Under $5,000'], ['5000-6999', '$5,000 – $6,999'], ['7000-8999', '$7,000 – $8,999'], ['9000-99999', '$9,000+']];

    var state = { people: new Set(), power: new Set(), price: new Set(), range: new Set(), size: new Set(), colour: new Set(), max: 9999, sort: 'featured' };

    function facetHTML(f) {
      var inner = '';
      if (f.type === 'price') {
        inner = '<div class="opts priceband">' + PRICE_BANDS.map(function (b) {
          return '<button class="opt" data-facet="price" data-val="' + b[0] + '" aria-pressed="false">' + b[1] + '</button>';
        }).join('') + '</div>' +
          '<input type="range" class="slider" min="4999" max="9999" step="1000" value="9999" data-slider>' +
          '<div class="sliderval"><span>$4,999</span><span>Up to $<b data-maxlbl>9,999</b></span></div>';
      } else if (f.type === 'sw') {
        inner = '<div class="opts">' + f.opts.map(function (o) {
          return '<button class="opt sw-opt" data-facet="colour" data-val="' + o[0] + '" aria-pressed="false"><span class="dot" style="background:' + o[2] + '"></span>' + o[1] + '</button>';
        }).join('') + '</div>';
      } else if (f.type === 'multifull') {
        inner = '<div class="opts">' + f.opts.map(function (o) {
          return '<button class="opt full" data-facet="' + f.key + '" data-val="' + o[0] + '" aria-pressed="false"><span class="meta"><span>' + o[1] + '</span><small>' + o[2] + '</small></span><span class="cnt" data-cnt="' + f.key + ':' + o[0] + '"></span></button>';
        }).join('') + '</div>';
      } else {
        inner = '<div class="opts">' + f.opts.map(function (o) {
          return '<button class="opt" data-facet="' + f.key + '" data-val="' + o[0] + '" aria-pressed="false">' + o[1] + '</button>';
        }).join('') + '</div>';
      }
      return '<div class="fg"><h3>' + f.title + '</h3>' + (f.hint ? '<div class="hint">' + f.hint + '</div>' : '') + inner + '</div>';
    }

    var panelBody = document.getElementById('panelBody');
    if (panelBody) panelBody.innerHTML = FACETS.map(facetHTML).join('');
    var rail = document.getElementById('rail');
    if (rail) rail.innerHTML =
      '<div class="railhd"><h2 class="railtitle">Filters</h2><span class="railclear" id="railClear">Clear all</span></div>' +
      FACETS.map(facetHTML).join('');

    function priceMatch(card) {
      var price = +card.dataset.price;
      if (price > state.max) return false;
      if (state.price.size === 0) return true;
      var ok = false;
      state.price.forEach(function (b) {
        var parts = b.split('-'); var lo = +parts[0], hi = +parts[1];
        if (price >= lo && price <= hi) ok = true;
      });
      return ok;
    }
    function matches(card) {
      var ds = card.dataset;
      if (state.people.size && !state.people.has(ds.people)) return false;
      if (state.power.size && !state.power.has(ds.power)) return false;
      if (state.range.size && !state.range.has(ds.series)) return false;
      if (state.size.size && !state.size.has(ds.size)) return false;
      // colour never narrows (all spas come in all 3 colours) — and must never
      // short-circuit the price check (bug found 2026-07-16: colour+price combo
      // silently ignored the price filter)
      if (!priceMatch(card)) return false;
      return true;
    }
    function activeTotal() {
      return state.people.size + state.power.size + state.price.size + state.range.size + state.size.size + state.colour.size + (state.max < 9999 ? 1 : 0);
    }

    var ORIG = [].slice.call(GRID.children);
    function cardList() { return [].slice.call(GRID.querySelectorAll('.card')); }

    function apply() {
      var grouped = state.sort === 'featured';
      var ords = {
        'price-asc': function (a, b) { return (+a.dataset.price) - (+b.dataset.price); },
        'price-desc': function (a, b) { return (+b.dataset.price) - (+a.dataset.price); },
        'jets': function (a, b) { return (+b.dataset.jets) - (+a.dataset.jets); },
        'seats': function (a, b) { return (+b.dataset.people) - (+a.dataset.people); }
      };
      var ord = ords[state.sort];
      var cards = cardList();
      var visible = 0;
      // restore grouped order or sort flat
      if (grouped) {
        ORIG.forEach(function (el) { GRID.appendChild(el); });
      } else {
        var arr = cards.slice();
        if (ord) arr.sort(ord);
        arr.forEach(function (c) { GRID.appendChild(c); });
      }
      cards.forEach(function (c) {
        var ok = matches(c);
        c.style.display = ok ? '' : 'none';
        if (ok) visible++;
      });
      // dividers: show only in grouped mode and if their series has a visible card
      [].forEach.call(document.querySelectorAll('.seriesdiv'), function (d) {
        if (!grouped) { d.style.display = 'none'; return; }
        var any = cardList().some(function (c) {
          return c.dataset.series === d.dataset.series && c.style.display !== 'none';
        });
        d.style.display = any ? '' : 'none';
      });
      var countEl = document.getElementById('count'); if (countEl) countEl.textContent = visible;
      var emptyEl = document.getElementById('empty'); if (emptyEl) emptyEl.style.display = visible ? 'none' : 'block';
      var t = activeTotal();
      var ac = document.getElementById('activeCount'); if (ac) { ac.style.display = t ? '' : 'none'; ac.textContent = t; }
      var apc = document.getElementById('applyCount'); if (apc) apc.textContent = visible;
      var ct = document.getElementById('clearTop'); if (ct) ct.style.display = t ? '' : 'none';
      // sync all option buttons to state
      [].forEach.call(document.querySelectorAll('.opt[data-facet]'), function (b) {
        var f = b.dataset.facet, v = b.dataset.val;
        b.setAttribute('aria-pressed', state[f].has(v) ? 'true' : 'false');
      });
      [].forEach.call(document.querySelectorAll('#peopleChips .chip[data-people]'), function (b) {
        var v = b.dataset.people;
        if (v === 'all') b.setAttribute('aria-pressed', state.people.size === 0 ? 'true' : 'false');
        else b.setAttribute('aria-pressed', state.people.has(v) ? 'true' : 'false');
      });
      [].forEach.call(document.querySelectorAll('#rangeChips .chip[data-range]'), function (b) {
        b.setAttribute('aria-pressed', state.range.has(b.dataset.range) ? 'true' : 'false');
      });
      [].forEach.call(document.querySelectorAll('#powerChips .chip[data-power]'), function (b) {
        b.setAttribute('aria-pressed', state.power.has(b.dataset.power) ? 'true' : 'false');
      });
    }

    function toggle(facet, val) {
      var s = state[facet];
      if (s.has(val)) s.delete(val); else s.add(val);
      apply();
    }
    // option buttons (panel + rail)
    document.addEventListener('click', function (e) {
      var opt = e.target.closest('.opt[data-facet]');
      if (opt) { toggle(opt.dataset.facet, opt.dataset.val); return; }
    });
    // price slider(s)
    [].forEach.call(document.querySelectorAll('[data-slider]'), function (sl) {
      sl.addEventListener('input', function () {
        state.max = +sl.value;
        [].forEach.call(document.querySelectorAll('[data-slider]'), function (o) { o.value = sl.value; });
        [].forEach.call(document.querySelectorAll('[data-maxlbl]'), function (o) { o.textContent = (+sl.value).toLocaleString(); });
        apply();
      });
    });
    // people quick chips
    var peopleChips = document.getElementById('peopleChips');
    if (peopleChips) peopleChips.addEventListener('click', function (e) {
      var c = e.target.closest('.chip[data-people]'); if (!c) return;
      var v = c.dataset.people;
      if (v === 'all') { state.people.clear(); }
      else { if (state.people.has(v)) state.people.delete(v); else state.people.add(v); }
      apply();
    });
    // series + power quick chips
    function chipRow(id, facet) {
      var el = document.getElementById(id); if (!el) return;
      el.addEventListener('click', function (e) {
        var c = e.target.closest('.chip[data-' + facet + ']'); if (!c) return;
        var v = c.dataset[facet];
        if (state[facet].has(v)) state[facet].delete(v); else state[facet].add(v);
        apply();
      });
    }
    chipRow('rangeChips', 'range'); chipRow('powerChips', 'power');
    // colour toggle on cards
    GRID.addEventListener('click', function (e) {
      var sw = e.target.closest('.sw[data-img]'); if (!sw) return;
      e.preventDefault();
      var card = sw.closest('.card');
      var img = card.querySelector('.cimg');
      if (img && sw.dataset.img) img.src = sw.dataset.img;
      [].forEach.call(card.querySelectorAll('.sw'), function (x) { x.classList.remove('active'); });
      sw.classList.add('active');
    });
    // sort
    var sortEl = document.getElementById('sort');
    if (sortEl) sortEl.addEventListener('change', function (e) { state.sort = e.target.value; apply(); });
    // clear
    function clearAll() {
      ['people', 'power', 'price', 'range', 'size', 'colour'].forEach(function (k) { state[k].clear(); });
      state.max = 9999;
      [].forEach.call(document.querySelectorAll('[data-slider]'), function (o) { o.value = 9999; });
      [].forEach.call(document.querySelectorAll('[data-maxlbl]'), function (o) { o.textContent = '9,999'; });
      apply();
    }
    ['clearTop', 'panelClear', 'railClear'].forEach(function (id) {
      var el = document.getElementById(id); if (el) el.addEventListener('click', clearAll);
    });
    // slide-over
    var scrim = document.getElementById('scrim'), panel = document.getElementById('panel');
    function openP() { if (scrim) scrim.classList.add('open'); if (panel) panel.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function closeP() { if (scrim) scrim.classList.remove('open'); if (panel) panel.classList.remove('open'); document.body.style.overflow = ''; }
    var openF = document.getElementById('openFilters'); if (openF) openF.addEventListener('click', openP);
    var closeF = document.getElementById('closeFilters'); if (closeF) closeF.addEventListener('click', closeP);
    var applyBtn = document.getElementById('panelApply'); if (applyBtn) applyBtn.addEventListener('click', closeP);
    if (scrim) scrim.addEventListener('click', closeP);

    // ---- chat CTAs -> Shopify Inbox widget (2026-07-28) ----
    // Mirrors spa-product.js. The Inbox V1 widget has no public open API; its activator sits
    // inside the <inbox-online-store-chat> shadow root, so clicking that is the only trigger.
    // Bounded retry covers async mount; phone is the fallback so a CTA is never a dead end.
    // Supports BOTH chat generations (this store flipped to the new agent widget 2026-07-29).
    // Mirrors spa-product.js; keep the two in step.
    function apsOpenChat(attempt) {
      var sc = document.querySelector('shopify-chat');
      if (sc && typeof sc.show === 'function') { try { sc.show(); return; } catch (err) {} }
      var act = sc && sc.shadowRoot && sc.shadowRoot.querySelector('button.activator');
      if (act) { act.click(); return; }
      var host = document.querySelector('inbox-online-store-chat');
      var toggle = host && host.shadowRoot && host.shadowRoot.querySelector('button.chat-toggle');
      if (toggle) { toggle.click(); return; }
      if ((attempt || 0) < 12) { setTimeout(function () { apsOpenChat((attempt || 0) + 1); }, 250); return; }
      var tel = document.querySelector('a[href^="tel:"]');
      if (tel) { window.location.href = tel.getAttribute('href'); }
    }

    document.addEventListener('click', function (e) {
      var el = e.target.closest('.aps-spa [data-aps-chat]');
      if (!el) return;
      e.preventDefault();
      var ref = el.getAttribute('data-aps-chat') || '';
      var sid;
      try { sid = sessionStorage.getItem('aps_sid') || ('s_anon_' + Date.now()); } catch (err) { sid = 's_anon_' + Date.now(); }
      var eid = 'aps_mc_' + sid + '_' + Date.now();
      if (window.fbq) { try { window.fbq('track', 'Contact', { content_name: 'Chat Click', content_category: ref }, { eventID: eid }); } catch (err) {} }
      if (window.gtag) { try { window.gtag('event', 'chat_click', { send_to: 'G-GDJ8QX7WM1', chat_ref: ref, page_path: location.pathname }); } catch (err) {} }
      if (window.dataLayer) { try { window.dataLayer.push({ event: 'chat_click', chat_ref: ref, chat_event_id: eid }); } catch (err) {} }
      apsOpenChat(0);
    });

    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
